import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="empty-state">
      <h2>Page not found</h2>
      <p>
        <Link to="/agents">Back to the agents list</Link>
      </p>
    </div>
  );
}
